<template>
  <div
    class="bg-secondary-3 border-radius--light border--top border--left border-top--color-secondary-12"
  >
    <div class="row">
      <div class="col-12 py-2 px-4">
        <div v-if="!editArticle" class="row">
          <div class="col-8 d-flex justify-content-left align-items-center">
            <span class="ml-4">{{ value.name }}</span>
          </div>
          <div class="col-4 text-right">
            <button class="btn btn-border-green mr-3" @click="onOpenClose">
              <i class="fas fa-edit text-green pr-1" />
            </button>
            <button class="btn btn-border-red mr-3" @click="onDelete">
              <i class="fas fa-times-circle text-red pr-1" />
            </button>
          </div>
        </div>
        <article-edit
          v-if="editArticle"
          :value="value.name"
          @onClose="onOpenClose"
          @onSaveArticle="(articleName) => onEdit(articleName)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import ArticleEdit from './ArticleEdit';

export default {
  name: 'ArticleRow',
  components: {
    ArticleEdit,
  },
  props: {
    value: {
      type: Object,
      default: () => {},
    },
  },
  data: () => ({
    editArticle: false,
  }),
  methods: {
    onOpenClose() {
      this.editArticle = !this.editArticle;
    },
    onDelete() {
      this.$emit('onDelete', this.value);
    },
    onEdit(articleName) {
      this.editArticle = !this.editArticle;
      const article = {
        id: this.value.id,
        name: articleName,
      };
      this.$emit('onEdit', article);
    },
  },
};
</script>

<style scoped>
.btn-border-green {
  border: 1px solid #2db782;
  border-radius: 4px;
  opacity: 1;
}

.btn-border-red {
  border: 1px solid #c9545e;
  border-radius: 4px;
  opacity: 1;
}
</style>
